import '../../global/actions/initial';

import type { FC } from '../../lib/teact/teact';
import React, { memo, useRef,useEffect,useState } from '../../lib/teact/teact';
import { getActions, withGlobal } from '../../global';

import type { GlobalState } from '../../global/types';

import { PLATFORM_ENV } from '../../util/windowEnvironment';

import useCurrentOrPrev from '../../hooks/useCurrentOrPrev';
import useElectronDrag from '../../hooks/useElectronDrag';
import useHistoryBack from '../../hooks/useHistoryBack';

import Transition from '../ui/Transition';
import AuthCode from './AuthCode.async';
import AuthPassword from './AuthPassword.async';
import AuthPhoneNumber from './AuthPhoneNumber';
import AuthQrCode from './AuthQrCode';
import AuthRegister from './AuthRegister.async';
import {getBaseconfig} from '../../util/keyword/keywordReplace'
import { getScreenBanner } from "../../util/keyword/keywordReplace";

import './Auth.scss';

type StateProps = Pick<GlobalState, 'authState'>;

const Auth: FC<StateProps> = ({
  authState,
}) => {
  const {
    returnToAuthPhoneNumber, goToAuthQrCode,setSettingOption
  } = getActions();

  const isMobile = PLATFORM_ENV === 'iOS' || PLATFORM_ENV === 'Android';

  const handleChangeAuthorizationMethod = () => {
    if (!isMobile) {
      goToAuthQrCode();
    } else {
      returnToAuthPhoneNumber();
    }
  };

  useHistoryBack({
    isActive: (!isMobile && authState === 'authorizationStateWaitPhoneNumber')
      || (isMobile && authState === 'authorizationStateWaitQrCode'),
    onBack: handleChangeAuthorizationMethod,
  });

  // eslint-disable-next-line no-null/no-null
  const containerRef = useRef<HTMLDivElement>(null);
  useElectronDrag(containerRef);

  // For animation purposes
  const renderingAuthState = useCurrentOrPrev(
    authState !== 'authorizationStateReady' ? authState : undefined,
    true,
  );
  useEffect(()=>{
    getBaseconfig().then(res=>{
        if (res) {
          // setSettingOption({ language: 'en' });
        }
    })
  },[])

  function getScreen() {
    switch (renderingAuthState) {
      case 'authorizationStateWaitCode':
        return <AuthCode />;
      case 'authorizationStateWaitPassword':
        return <AuthPassword />;
      case 'authorizationStateWaitRegistration':
        return <AuthRegister />;
      case 'authorizationStateWaitPhoneNumber':
        return <AuthPhoneNumber />;
      case 'authorizationStateWaitQrCode':
        return <AuthQrCode />;
      default:
        return isMobile ? <AuthPhoneNumber /> : <AuthQrCode />;
    }
  }

  function getActiveKey() {
    switch (renderingAuthState) {
      case 'authorizationStateWaitCode':
        return 0;
      case 'authorizationStateWaitPassword':
        return 1;
      case 'authorizationStateWaitRegistration':
        return 2;
      case 'authorizationStateWaitPhoneNumber':
        return 3;
      case 'authorizationStateWaitQrCode':
        return 4;
      default:
        return isMobile ? 3 : 4;
    }
  }
  const [screenBanner, setScreenBanner] = useState<{ image: string, baseimage: string, openurl?: string }[]>([]);
  const [showBanner,setShowBanner] = useState(true)
  useEffect(()=>{
    getScreenBanner().then(res=>{
      if (res) {
        setScreenBanner(res.data.list)
      }
    })
  },[])
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % screenBanner.length);
    }, 1500);
    return () => clearInterval(interval);
  }, [screenBanner.length]);
  const handleBannerClick = (item: { openurl?: string })=>{
    if(item.openurl) {
      window.open(item.openurl)
    }
  }

  return (
    <Transition activeKey={getActiveKey()} name="fade" className="Auth" ref={containerRef}>
        {showBanner&&screenBanner.length > 0 && (
          <div className="banner_Container" >
            {screenBanner.map((item,index) => (
              <img
                key={index}
                className="banner"
                style={`transform: translateX(-${currentIndex * 100}%)`}
                src={"data:image/png;base64," + item.baseimage}
                alt="cao"
                onClick={() => handleBannerClick(item)}
              />
            ))}
            <div className="close" onClick={() =>setShowBanner(false)}>+</div>
          </div>
        )}
      {getScreen()}
    </Transition>
  );
};

export default memo(withGlobal(
  (global): StateProps => {
    return {
      authState: global.authState,
    };
  },
)(Auth));
